/* eslint-disable prettier/prettier */
import { FETCH_ERROR, SHOW_MESSAGE, SHOW_ERROR_MESSAGE, SET_UPDATING } from '@crema/types/actions/Common.action';
import { createAction } from '@reduxjs/toolkit';

export const ShowMsgAction = createAction<string>(SHOW_MESSAGE);
export const FetchErrorAction = createAction<string>(FETCH_ERROR);
export const ShowErrorMessage = createAction<string>(SHOW_ERROR_MESSAGE);
export const SetUpdating = createAction<any>(SET_UPDATING);
